import Colors from "../../styles/colors";

const styles = {
  container: {
    flexDirection: "column",
    height: "calc(100vh - 112px)",
    maxHeight: "calc(100vh - 112px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "16px",
  },
  conversationContainer: {
    mb: 1,
    p: 2,
    height: "100%",
    maxHeight: "100%",
    flexDirection: "column",
    width: "100%",
    maxWidth: 1200,
    overflow: "auto",
    boxShadow: "0px 4.12px 25.75px 0px #0000000D",
    "&::-webkit-scrollbar": {
      height: "10px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: Colors.Highnote.blue4T10,
      borderRadius: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      boxShadow: "0px 4.12px 25.75px 0px #0000000D",
      height: "10px",
      backgroundColor: Colors.Highnote.blue4T90,
      borderRadius: "8px",
    },
  },
  inputContainer: {
    p: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: 1200,
  },
  inputDivider: {
    minHeight: 48,
    m: 1,
    ml: 2.5,
    height: "100%",
  },
  onboardingPrompt: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#F8F9FA",
    p: 3,
    borderRadius: "12px",
  },
  hignomeAvatarOnboarding: {
    width: 56,
    height: 56,
    mr: 2,
    p: 1,
    border: "2px solid transparent",
    background:
      "linear-gradient(#fff, #fff) padding-box, linear-gradient(45deg, #f81ce5, #7928ca) border-box",
  },
  onboardingAvatar: {
    width: 56,
    height: 56,
    mr: 2,
  },
  systemMessagecontainer: {
    m: 1,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    borderColor: "red",
    borderWidth: "2px",
    marginBottom: "18px",
    maxWidth: "100%",
  },
  userMessageContainer: {
    m: 1,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-end",
    borderColor: "blue",
    borderWidth: "8px",
    marginBottom: "18px",
    maxWidth: "100%",
  },
  systemMessage: {
    maxWidth: "80%",
    paddingLeft: "16px",
    paddingRight: "16px",
    marginLeft: "8px",
    color: Colors.Highnote.black,
    backgroundColor: "#E9ECEF",
    borderRadius: "12px"
  },
  hignomeAvatar: {
    marginTop: "4px",
    padding: "3px",
    border: "2px solid transparent",
    background:
      "linear-gradient(#fff, #fff) padding-box, linear-gradient(45deg, #f81ce5, #7928ca) border-box",
  },
  userMessage: {
    maxWidth: "80%",
    paddingLeft: "16px",
    paddingRight: "16px",
    marginRight: "8px",
    backgroundImage: `linear-gradient(to right, ${Colors.Highnote.blue1}, ${Colors.Highnote.purple3})`,
    color: Colors.Highnote.white,
    borderRadius: "12px",
  },
  loadingContainer: {
    m: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  inputProps: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "59px",
    borderRadius: "7px",
    paddingRight: "15px",
    paddingLeft: "15px",
    backgroundColor: "white",
    letterSpacing: "0%",
    color: "#67748E",
  },
  fieldLabel: {
    fontFamily: "Steradian, sans-serif",
    fontWeight: 600,
    fontSize: "14px",
    color: "#67748E",
  },
  feedbackBaseContainer: {
    marginTop: "24px",
  },
  feedbackContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  feedbackText: {
    color: "#67748E",
    textAlign: "center",
    fontFamily: "Steradian",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    marginBottom: "8px",
  },
  voteIconsContainer: {
    display: "flex",
    alignItems: "center",
  },
  voteOptionBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  thumbsUpBox: {
    marginRight: "16px"
  },
  thumbIcon: {
    width: "28px",
    height: "28px",
    cursor: "pointer",
    marginBottom: "8px",
  },
  voteLabel: {
    color: "#67748E",
    textAlign: "center",
    fontFamily: "Steradian",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal",
    letterSpacing: "0.6px",
    textTransform: "uppercase",
  },
  popoverBox: {
    width: "483px",
    display: "inline-flex",
    padding: "16px",
    flexDirection: "column",
    alignItems: "flex-start",
    background: "#cbd0d9",
  },
  popoverHeader: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
    gap: "12px",
  },
  popoverHeaderText: {
    fontFamily: "Steradian",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
  },
  feedbackTextField: {
    display: "flex",
    width: "451px",
    height: "104px",
    padding: "8px 12px",
    alignItems: "flex-start",
    gap: "10px",
    borderRadius: "8px",
    background: "#fff",
    marginBottom: "20px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none", 
      },
      "&.Mui-focused fieldset": {
        border: "none", 
      },
    },
  },
  submitButton: {
    display: "flex",
    padding: "12px 32px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "28px",
    backgroundColor: "white",
    border: "2px solid black",
    color: "#363636",
    textAlign: "center",
    fontFamily: "Steradian",
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    letterSpacing: "-0.2px",
    textTransform: "none",
    cursor: "pointer",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none", 
      background: "white"
    },
    "&:active": {
      boxShadow: "none",
    },
  },
};

export default styles;